import instObj from '@/backend/axios-instances'

const resource = "/document"
const instance = instObj.baseInstance

export default {
  get(id, parameters) {
    return instance.put(`${resource}/${id}`, { params: parameters });
  },
  put(id, data, parameters) {
    return instance.put(`${resource}/${id}`, data, { params: parameters });
  },
  delete(id, parameters) {
    return instance.delete(`${resource}/${id}`, { params: parameters });
  },
  addAttachment(id, data, parameters) {
    return instance.post(`${resource}/${id}/attachment`, data, { params: parameters })
  }
}
